import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return String(value).padStart(2, '0');
}
type CountdownProps = {
  label?: string;
  className?: string;
};
export function Countdown({
  label = 'The offer ends in',
  className = ''
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    unit: 'HRS'
  }, {
    value: pad(minutes),
    unit: 'MIN'
  }, {
    value: pad(seconds),
    unit: 'SEC'
  }];
  return <div className={`w-full ${className}`} data-id="element-20" data-mp="10d4prpgbyaj7">
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-ember sm:text-xs" data-id="element-21" data-mp="15by7xv6kappp">
        {label}
      </p>
      <div className="mt-2 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-22" data-mp="xzvgr94povz2">
        {units.map(u => <div key={u.unit} className="flex min-w-[68px] flex-col items-center rounded-lg border border-white/10 bg-ink-800 px-3 py-2 sm:min-w-[84px]" data-id="element-23" data-mp="17qq46gtp21m3">
            <span className="font-display text-3xl font-bold leading-none text-white tabular-nums sm:text-4xl" data-id="element-24" data-mp="f2atu7lic7h3">
              {u.value}
            </span>
            <span className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-white/40" data-id="element-25" data-mp="a4sgm50gj63a">
              {u.unit}
            </span>
          </div>)}
      </div>
    </div>;
}